import React, { useState } from 'react';

const InfoTooltip: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="info-tooltip-container">
      <div 
        className="info-icon"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        ℹ️
      </div>
      {showTooltip && (
        <div className="tooltip">
          <h4>Controls:</h4>
          <ul>
            <li>↑ - Rotate</li>
            <li>↓ - Move Down</li>
            <li>← - Move Left</li>
            <li>→ - Move Right</li>
            <li>Space - Hard Drop</li>
            <li>ESC - Pause/Resume</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;